import styles from '../../styles/style.module.scss';
import voeryLogo from '../../../../assets/images/logo.png';

import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { t } from '@web-solutions/module-localization';

export const VoeryCallComponent = () => {
  return (
    <>
      <div className={styles.voeryCall}>
        <div className={styles.logoContainer}>
          <img src={voeryLogo} alt='voery logo' />
          <div className={styles.logoDescr}>
            <Typography variant='h1-bold' className={styles.voeryTitle}>
              {t('onboarding.voeryPersonalPlan.voery')}
            </Typography>
            <Typography variant='body-semibold' className={styles.voerySubtitle}>
              {t('onboarding.voeryPersonalPlan.aiCall')}
            </Typography>
          </div>
        </div>
        <Typography variant='callout-medium' className={styles.voeryCallDesc}>
          {t('onboarding.voeryPersonalPlan.voeryCall.title')}
        </Typography>
      </div>
    </>
  );
};
